var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_show)?_c('div',{staticClass:"new-award",style:({
  'margin-top': _vm.cc.margin_top + 'px' || _vm.gc.margin_top + 'px',
  'margin-bottom': _vm.cc.margin_bot + 'px' || _vm.gc.margin_bot + 'px',
  })},[_c('img',{staticClass:"bg",attrs:{"src":_vm.cc.bg_img,"alt":""}}),_c('div',{staticClass:"receive-btn",style:({'background-image': `url(${_vm.btn_bg})`, 'color': _vm.gc.text_color}),on:{"click":_vm.receive}},[_vm._v("\n    "+_vm._s(_vm.btn_desc)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }